// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import { UseQueryResult } from "@tanstack/react-query";
import {
  getLoginPrefill,
  getPublicCapacity,
  getPublicOrganizationPathByClientId,
} from "../requests/services.gen";
import {
  GetLoginPrefillData,
  GetPublicCapacityData,
  GetPublicOrganizationPathByClientIdData,
} from "../requests/types.gen";
export type GetPublicOrganizationPathByClientIdDefaultResponse = Awaited<
  ReturnType<typeof getPublicOrganizationPathByClientId>
>["data"];
export type GetPublicOrganizationPathByClientIdQueryResult<
  TData = GetPublicOrganizationPathByClientIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetPublicOrganizationPathByClientIdKey =
  "GetPublicOrganizationPathByClientId";
export const UseGetPublicOrganizationPathByClientIdKeyFn = (
  clientOptions: Options<GetPublicOrganizationPathByClientIdData, true>,
  queryKey?: Array<unknown>
) => [
  useGetPublicOrganizationPathByClientIdKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetLoginPrefillDefaultResponse = Awaited<
  ReturnType<typeof getLoginPrefill>
>["data"];
export type GetLoginPrefillQueryResult<
  TData = GetLoginPrefillDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetLoginPrefillKey = "GetLoginPrefill";
export const UseGetLoginPrefillKeyFn = (
  clientOptions: Options<GetLoginPrefillData, true>,
  queryKey?: Array<unknown>
) => [useGetLoginPrefillKey, ...(queryKey ?? [clientOptions])];
export type GetPublicCapacityDefaultResponse = Awaited<
  ReturnType<typeof getPublicCapacity>
>["data"];
export type GetPublicCapacityQueryResult<
  TData = GetPublicCapacityDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetPublicCapacityKey = "GetPublicCapacity";
export const UseGetPublicCapacityKeyFn = (
  clientOptions: Options<GetPublicCapacityData, true>,
  queryKey?: Array<unknown>
) => [useGetPublicCapacityKey, ...(queryKey ?? [clientOptions])];
